import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Components/General/Tabs
 * ----------------------------------------------------------------------
 * Container para abas.
 */
class Tabs extends Component {
  constructor (props) {
    super(props);

    this.state = {
      current: this.props.current || 0
    };
  }

  render () {
    const { props } = this;

    return (
      <div className={classnames(props.className)}>
        <ul className={classnames(props.navigationClass)}>
          {this.renderTabs()}
        </ul>
        <div className={classnames(props.contentClass)}>
          {this.renderChildren()}
        </div>
      </div>
    );
  }
  
  componentDidMount () {
    let {
      children,
      activeTab
    } = this.props;

    if (children && children.length > 0) {
      for (let n = 0; n < children.length; n++) {
        let item = children[n];
        let tabName = item.props.label || null;
        let tabId = item.props.tabId;
        if (activeTab && tabId && activeTab === tabId) {
          this.setState({
            current: n
          });
        }
      }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.activeTab !== prevProps.activeTab) {
      let {
        children,
        activeTab
      } = this.props;
      
      for (let n = 0; n < children.length; n++) {
        let item = children[n];
        let tabName = item.props.label || null;
        let tabId = item.props.tabId;
        if (activeTab && tabId && activeTab === tabId) {
          this.setState({
            current: n
          });
        }
      }
    }
  }

  currentTab = (index, tabId) => {
    return () => {
      this.setState({
        current: index || 0
      }, () => {
        const {
          history
        } = this.props;

        if (this.props.parentPage && tabId !== "") {
          history.push(`${this.props.parentPage}/${tabId}`);
        } else if (this.props.parentPage) {
          history.push(`${this.props.parentPage}`);
        }
      });
    };
  };

  renderTabs = () => {
    const {
      children,
      navigationLinkClass,
      navigationLinkActiveClass,
      activeTab
    } = this.props;

    if (children === null) return null;

    return children.map((item, key) => {
      let _cls = [
        navigationLinkClass
      ];

      if (key === this.state.current) {
        _cls.push(navigationLinkActiveClass);
      }

      let tabName = item.props.label || null;
      
      return (
        <li key={key}
            className={classnames(_cls)}>
          <button onClick={this.currentTab(key, item.props.tabId)}>
            {tabName}
          </button>
        </li>
      );
    });
  };

  renderChildren = () => {
    const { children } = this.props;

    if (children === null) return null;

    return children.map((item, key) => {
      return (key === this.state.current) ? item : null;
    });
  };
}

let classNamePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.string)
]);

Tabs.defaultProps = {
  parentPage: null,
  current: 0,
  className: "tabbed-view",
  navigationClass: "tabbed-view__nav",
  navigationLinkClass: "tabbed-view__nav-link",
  navigationLinkActiveClass: "active",
  contentClass: "tabbed-view__contents"
};

Tabs.propTypes = {
  parentPage: PropTypes.string,
  activeTab: PropTypes.string,
  children: PropTypes.node.isRequired,
  current: PropTypes.number,
  className: classNamePropType,
  navigationClass: classNamePropType,
  navigationLinkClass: classNamePropType,
  navigationLinkActiveClass: classNamePropType,
  contentClass: classNamePropType
};

Tabs = withRouter(Tabs);

export { Tabs };
